export class GeneralHelpers {
  public static copyCliboard(text: string) {
    navigator.clipboard.writeText(text);
  }
}
